import { useState, useEffect } from 'react'
// import { Header } from './../header'
// import { Footer } from './../footer'
// import { useAuthState } from 'context'
import { LoginModal } from 'components/modals/LoginModal'
import { SmsModal } from 'components/modals/SmsModal'
// import { RegModal } from 'components/modals/RegModal'
import { PassResetModal } from 'components/modals/PassResetModal'
import { SuccessModal } from 'components/modals/SuccessModal'
import { PastSuccessModal } from 'components/modals/PastSuccessModal'
import { CallbackModal } from 'components/modals/CallbackModal'
import { SuccessCallback } from 'components/modals/SuccessCallback'

import 'components/forms/style.scss'
export const MainLayout = ({
  children,
  openPhoneModal,
  openPassResetModal,
  openSuccessModal,
  openRegModal,
  setMidlwareRegModal,
  setMidlwarePhoneModal,
  setMidlwarePassResetModal,
  setMidlwareSuccessModal,
}) => {
  // const { userDetails } = useAuthState()
  const [phoneModal, setPhoneModal] = useState(false)
  const [smsModal, setSmsModal] = useState(false)
  const [regModal, setRegModal] = useState(false)
  const [passResetModal,setPassResetModal ] = useState(false)
  const [successModal, setSuccessModal] = useState(false)
  const [pastSuccessModal, setPastSuccessModal] = useState(false)
  const [callbackModal, setCallbackModal] = useState(false)
  const [successCallback, setSuccessCallback] = useState(false)

  const [isNew, setIsnew] = useState(false)
  const [phone, setPhone] = useState('')
  const [expiredIn, setExpiredIn] = useState(5)

  useEffect(() => {
    if (openPhoneModal) {
      setPhoneModal(true)
    }
    if (openRegModal) {
      setRegModal(true)
    }
    if (openPassResetModal) {
      console.log('here')
      setPassResetModal(true)
    }
    if (openSuccessModal) {
      setSuccessModal(true)
    }
  }, [openPhoneModal, openPassResetModal, openSuccessModal,openRegModal])
  useEffect(() => {
    if (!phoneModal && setMidlwarePhoneModal) {
      setMidlwarePhoneModal(false)
    }
    if (!regModal && setMidlwareRegModal) {
      setMidlwareRegModal(false)
    }
    if (!passResetModal && setMidlwarePassResetModal) {
      setMidlwarePassResetModal(false)
    }
    if (!successModal && setMidlwareSuccessModal) {
      setMidlwareSuccessModal(false)
    }
  }, [
    phoneModal,
    passResetModal,
    successModal,
    regModal,
    setMidlwarePhoneModal,
    setMidlwareRegModal,
    setMidlwarePassResetModal,
    setMidlwareSuccessModal,
  ])

    useEffect(()=> {
        const { pathname } = window.location
        if (pathname === '/profile') {
            document.body.classList.add('_is_profile')
        } else {
            document.body.classList.remove('_is_profile')
        }
    })

  return (
    <>
      {/* <Header
        openPhoneModal={(e) => {
          setPhoneModal(e)
        }}
        openCallbackModal={(e) => {
          setCallbackModal(e)
        }}
        // openAnketModal={(e) => {
        //   if (!userDetails || !userDetails.name) {
        //     setPhoneModal(true)
        //   } else {
        //     if (userDetails.finished_anket) {
        //       setPastSuccessModal(true)
        //     }
        //   }
        // }}
      /> */}
      <main>{children}</main>
      {/* <Footer /> */}
      <LoginModal
        nextStep={() => {
          setPhoneModal(false)
          setSmsModal(true)
        }}
        setIsnew={setIsnew}
        setPhone={setPhone}
        setExpiredIn={setExpiredIn}
        isOpen={phoneModal}
        setIsOpen={setPhoneModal}
        setMidlwarePassResetModal={setMidlwarePassResetModal}
      />
      <SmsModal
        phone={phone}
        isNew={isNew}
        expired={Math.round((300 - expiredIn) / 60)}
        setExpired={setExpiredIn}
        nextStep={() => {
          setSmsModal(false)
          setRegModal(true)
        }}
        isOpen={smsModal}
        setIsOpen={setSmsModal}
      />
      {/* <RegModal setMidlwareSuccessModal={setMidlwareSuccessModal} isOpen={regModal} setIsOpen={setRegModal} /> */}
      <PassResetModal
        isOpen={passResetModal}
        setIsOpen={setPassResetModal}
      />
      <SuccessModal isOpen={successModal} setIsOpen={setSuccessModal} />
      <PastSuccessModal
        isOpen={pastSuccessModal}
        setIsOpen={setPastSuccessModal}
      />
      <CallbackModal
        isOpen={callbackModal}
        setIsOpen={setCallbackModal}
        setSuccess={() => {
          setCallbackModal(false)
          setSuccessCallback(true)
        }}
      />
      <SuccessCallback
        isOpen={successCallback}
        setIsOpen={setSuccessCallback}
      />
    </>
  )
}
